<template>
  <div style="padding: 0 8px" :class="{detail_main:isActive}">
    <!--<div>-->
    <!--  <span style="font-weight: bold">采购单号: </span>{{ item.purchase_no }}-->
    <!--</div>-->
    <div>
      <span style="font-weight: bold">包裹号: </span>{{ item.order_number }}
    </div>
    <!--<div><span style="font-weight: bold">交易编号: </span>{{ item.transaction_no }}</div>-->
    <div class="show">
      <div class="line">
        <el-row>
          <el-col :span="12">
            <div class="grid-content bg-purple"
                 style="color: #bd2c00">
              <h3>订单编号</h3>
              <p>{{ item.transaction_number }}</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <h3>数量</h3>
              <p style="color:  #bd2c00">{{ item.quantity }}</p>
            </div>
          </el-col>
          <!--          <el-col :span="12">
                      <div class="grid-content bg-purple-light">
                        <h3>SKU</h3>
                        <p>{{ item.sku }}</p>
                      </div>
                    </el-col>-->
          <!--          <el-col :span="12">
                      <div class="grid-content bg-purple-light">
                        <h3>商品中文名称</h3>
                        <p>{{ item.product_name }}</p>
                      </div>
                    </el-col>-->
          <el-col :span="24" v-if="item.word!==null">
            <div class="grid-content bg-purple-light">
              <p><span style="font-weight: bold">定制文案</span>: <span style="color: red">{{ item.word }}</span></p>
            </div>
          </el-col>
          <el-col :span="24" v-if="item.remark">
            <div class="grid-content bg-purple-light">
              <!--<p>备注:</p>-->
              <p><span style="font-weight: bold">备注</span>: <span>{{ item.remark }}</span></p>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content bg-purple-light">
              <p v-if="item.status===0">状态: <span style="color: #9a6e3a">未验收</span></p>
              <p v-else-if="item.status===1">状态: <span style="color: #55a532">完成</span></p>
              <p v-else-if="item.status===2">状态: <span style="color: red">异常</span></p>
              <p v-else-if="item.status===3">状态: <span style="color: #3a8ee6">已拣货</span></p>
              <p v-else>状态: 其它</p>
            </div>
          </el-col>

          <template v-if="item.shelf_id===null">
            <el-col :span="24" v-if="item.history_shelf_id!==null">
              <div class="grid-content bg-purple-light">
                <p>历史货架号: {{ item.history_shelf.shelf_no }} </p>
              </div>
            </el-col>
          </template>

          <el-col :span="24" v-if="item.accept_at">
            <div class="grid-content bg-purple-light">
              <p>时间: {{ item.accept_at }} </p>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content bg-purple-light">
              <div class="pd-img">
                <img :src="item.image_url" alt="" preview="1" preview-text='图片展示'/>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

    </div>

    <div class="check-box">
      <el-form ref="form" :model="form" label-width="50px">
        <template v-if="fast_remark">
          <el-form-item label="备注">
            <el-input v-model="form.remark"></el-input>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="备注">
            <el-select v-model="form.remark" placeholder="请选择快速备注信息">
              <el-option label="定制信息错误" value="定制信息错误"></el-option>
              <el-option label="产品破损" value="产品破损"></el-option>
              <el-option label="数量不对" value="数量不对"></el-option>
              <el-option label="印刷质量差" value="印刷质量差"></el-option>
              <el-option label="其它" value="其它"></el-option>
              <el-option label="移除备注" value=""></el-option>
            </el-select>
          </el-form-item>
        </template>

        <el-form-item>
          <el-button type="info" size="small" @click.prevent="fast_remark=!fast_remark" v-if="fast_remark">切换到快速备注
          </el-button>
          <el-button type="warning" size="small" @click.prevent="fast_remark=!fast_remark" v-else>切换到自定义备注</el-button>
        </el-form-item>

        <el-form-item label="货架" v-if="!shelf_off">
          <el-select v-model="form.shelf_id" placeholder="请选择货架号" :disabled="shelf_off">
            <template v-for="item of shelves">
              <template v-if="item.order_count>=500">
                <!--<el-option :key="item.id" :label="item.shelf_no+' &#45;&#45;'+item.order_count+' 已满'" :value="item.id" disabled></el-option>-->
                <el-option :key="item.id" :label="item.shelf_no+'   已满'" :value="item.id" disabled></el-option>
              </template>
              <template v-else>
                <el-option :key="item.id" :label="item.shelf_no" :value="item.id"></el-option>
                <!--<el-option :key="item.id" :label="item.shelf_no+' &#45;&#45;'+item.order_count+'&#45;&#45;'" :value="item.id"></el-option>-->
              </template>
            </template>
            <!--<el-option label="LSA14" value="2"></el-option>-->
          </el-select>
        </el-form-item>

      </el-form>
    </div>

    <el-row class="button-box">
      <el-button style="margin-bottom: 1rem" type="primary" @click.prevent="onSubmit(1)">完成</el-button>
      <el-button style="margin-bottom: 1rem;margin-left: 3rem" type="danger" @click.prevent="onSubmit(2)">异常</el-button>
    </el-row>

    <div class="wav">
      <audio id="audioMusic" class="audio" src="@/assets/wav/didi.wav" controls hidden="true" ref="audio"></audio>
      <audio id="failMusic" class="audio" src="@/assets/wav/yichang.wav" controls hidden="true" ref="audio"></audio>
    </div>
  </div>

</template>

<script>
// import Bus from '@/assets/js/bus';
export default {
  name: "B2bDetail",
  data() {
    return {
      // isActive:false,
      fast_remark: false,
      item: {},
      form: {
        // remark:this.$route.query.remark,
        remark: '',
        // shelf_id:this.$route.query.lock_shelf?this.$route.query.lock_shelf:this.$route.query.shelf_id
        shelf_id: ''
      },
      shelves: [],
      // lock:!!this.$route.query.lock_shelf
      // lock:""
    }
  },
  methods: {

    latestSecurityIncidents() {
      //同时 触发提示音
      document.getElementById('audioMusic').play();
    },

    failMusic() {
      document.getElementById('failMusic').play();
    },

    onSubmit(s) {
      // 判断多品验收是否启用货架
      if (this.item.config === "1") {
        if (this.shelf_off === false && this.form.shelf_id === null) {

          const h = this.$createElement;
          this.$message({
            offset: 50,
            duration: 3000,
            message: h('p', null, [
              h('span', null, '多品验收必须选择货架 '),
              // h('i', { style: 'color: teal' }, 'VNode')
            ])
          });
          return false;
        }
      }


      if (s === 1) {
        this.latestSecurityIncidents()
      }

      if (s === 2) {
        if (this.form.remark == null||this.form.remark === '') {
          const h = this.$createElement;
          this.$message({
            offset: 50,
            duration: 3000,
            message: h('p', null, [
              h('span', null, '异常订单请填写备注信息 '),
              // h('i', { style: 'color: teal' }, 'VNode')
            ])
          });
          return false;
        }
        this.failMusic()
      }
      // alert(35)
      let param = {
        id: this.item.id,
        status: s,
      }
      if (this.form.remark !== "") {
        param.remark = this.form.remark
      }
      if (this.form.shelf_id !== "") {
        param.shelf_id = this.form.shelf_id
      }

      console.log(param);
      this.http.fetchPost(this.api.b2bCheck, param).then((res) => {
        // console.log(res)
        let data = res.data
        if (data.code === 200) {
          const h = this.$createElement;
          this.$message({
            offset: 50,
            duration: 1000,
            message: h('p', null, [
              h('span', null, '提交成功 '),
              // h('i', { style: 'color: teal' }, 'VNode')
            ])
          });
          let _this = this
          setTimeout(function () {
            _this.$router.push({
              path: "/b2b-check",
              query: {
                order_number: _this.item.order_number
              }

            })
          }, 1000)

        }
      }).catch(err => {
        console.log(err)
      })

    },
    getShelf() {
      this.http.fetchGet(this.api.getB2bShelfUrl).then((res) => {
        let data = res.data
        if (data.code === 200) {

          this.shelves = data.data


        } else {
          this.$message.error("获取仓库列表失败,请刷新页面")
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  created() {
    let _this = this
    this.$EventBus.$off("order").$on("order", res => {
      console.log(res)
      _this.item = res;
      _this.form.remark = _this.item.remark;
      _this.form.shelf_id = _this.item.lock_shelf ? this.item.lock_shelf : this.item.shelf_id;
      // _this.lock=!!_this.item.lock_shelf
      // console.log(_this.item.order_number)
    })
  },
  computed: {
    // item(){
    //   // console.log(this.$route.query)
    //   return this.$route.query
    // },
    isActive() {
      if (this.item.is_change === 1) {
        return true
      } else {
        return false
      }
    },

    lock() {
      return !!this.item.lock_shelf
    },

    shelf_off() {
      // if (this.$route.query.shelf_off == 1) {
      if (this.item.shelf_off == 1) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {

    /* Bus.$off("order")
     Bus.$on("order",res=>{
       console.log(res)
       this.item=res;
       console.log(this.item.order_number)
     })*/

    this.getShelf()
    //第二种方法
    document.onkeydown = () => {
      let key = window.event.keyCode;
      // alert(key)
      // console.log(key)
      if (key === 73) {
        this.onSubmit(1)
      }
    }

  },
}
</script>

<style scoped lang="stylus">

.detail_main
  background-color #fbfa90c4

.show {
  //float: left;
  width: 100%;

  .line {
    box-sizing: border-box;
    border: 1px solid black;
    //margin-top: 1rem;
    margin: 1px;
    //float: left;
    width: 100%;

    .pd-img {
      img {
        width 100%
      }
    }

    .el-col {
      margin-top 5px
      margin-bottom: 5px;
      padding 0 5px

      &:last-child {
        //margin-bottom: 0;
      }
    }

    .grid-content {
      //text-align center

      h3 {
        font-size 14px
      }
    }

  }
}


.check-box {
  margin-top 5px

  .el-select {
    width 100%
  }
}

.button-box
  text-align center

</style>
